import { render, staticRenderFns } from "./ThreeSectionLayout.vue?vue&type=template&id=4c684208&"
import script from "./ThreeSectionLayout.vue?vue&type=script&lang=js&"
export * from "./ThreeSectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports